import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-specialties',
  templateUrl: './specialties.component.html',
  styleUrls: ['./specialties.component.scss']
})
export class SpecialtiesComponent implements OnInit, OnDestroy{
  language: any;
  SpecialtyDoctors;
  DoctorImg:boolean []= [];
  DoctorAbout:boolean [] = [];
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 
  HospitalSpecialties$:any[]=[];
  AllHospitalSpecialties$:any[]=[];

  constructor(private metaTagService: Meta,private HospitalService: HospitalService, private route: ActivatedRoute,private router: Router,
    private translationService: TranslationService) { }
  ngOnInit(): void {
    this.metaTagService.updateTag({ 
      name: 'description', 
      content: 'Expert pediatric care in Saudi Arabia, ensuring the health and well-being of your children with compassionate and comprehensive medical services.' 
    });
    this.metaTagService.updateTag({ 
      name: 'keywords', 
      content: "pediatric care, children's health services, Saudi Arabia healthcare, family medical care" 
    });
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
    this.LoadAllSpecialties();
    this.LoadAllDoctors();
  }
  LoadAllSpecialties() {
    const sb =  this.HospitalService.GetHospitalDepartments().subscribe(res =>
      {
        this.HospitalSpecialties$ = res
        this.AllHospitalSpecialties$ = res
      });
    this.subscriptions.push(sb);
  }
  OnSearchSpecialty(Specialty) {
    let SearchTerm = Specialty.term;
    this.HospitalSpecialties$ =this.AllHospitalSpecialties$.filter(x => x.departmentName.toLower().includes(SearchTerm.toLower()) || x.departmentNameArabic.includes(SearchTerm))
    
  }
 
  OnChangeSpecialty(SpecialtyId)
  {
    const sb = this.HospitalService.GetAllDoctorsByDepartmentId(SpecialtyId).subscribe(res => {
      if (res != null) {
        this.SpecialtyDoctors = res;
        for(let i = 0 ; i < res.length ; i++)
        {
          this.DoctorImg[i] = true;
        }
      }
    });
    this.subscriptions.push(sb);
  }

  LoadAllDoctors(){
    const sb = this.HospitalService.GetAllDoctorsByDepartmentId(0).subscribe(res => {
      if (res != null) {
        this.SpecialtyDoctors = res;
        for(let i = 0 ; i < res.length ; i++)
        {
          this.DoctorImg[i] = true;
        }
      }
    });
    this.subscriptions.push(sb);
  }
  // OnChangeSpecialty(event)
  // {
  //   let SpecialtyId = event.target.options[event.target.options.selectedIndex].value;
  //   const sb = this.HospitalService.GetAllDoctorsByDepartmentId(SpecialtyId).subscribe(res => {
  //     if (res != null) {
  //       this.SpecialtyDoctors = res;
  //       for(let i = 0 ; i < res.length ; i++)
  //       {
  //         this.DoctorImg[i] = true;
  //       }
  //     }
  //   });
  //   this.subscriptions.push(sb);
  // }
  OnMouseEnter(index)
  {
    this.DoctorImg[index] = false;
    this.DoctorAbout[index] = true;
  }
  OnMouseLeave(index)
  {
    this.DoctorImg[index] = true;
    this.DoctorAbout[index] = false;
  }
  GetAppointment(DepartmentId,EmployeeId)
  {
    sessionStorage.setItem('DepartmentId',DepartmentId);
    sessionStorage.setItem('DoctorId',EmployeeId);
    this.router.navigate(['/doctorslots/'+DepartmentId +'/'+EmployeeId], { relativeTo: this.route });
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }


}
